import { defineMessages } from '@jutro/locale';

export default defineMessages({
    unsopportedBrowserMessage: {
        id: 'jutro.component.unsupportedbrowserbanner.unsopportedBrowserMessage',
        defaultMessage:
            'It looks like your browser isn’t fully supported and may not work as expected. For the best experience, please switch to a recommended browser from our list.',
    },
    chromeBrowser: {
        id: 'jutro.component.unsupportedbrowserbanner.chromeBrowser',
        defaultMessage: 'Chrome',
    },
    edgeBrowser: {
        id: 'jutro.component.unsupportedbrowserbanner.edgeBrowser',
        defaultMessage: 'Edge',
    },
    safariBrowser: {
        id: 'jutro.component.unsupportedbrowserbanner.safariBrowser',
        defaultMessage: 'Safari',
    },
    firefoxBrowser: {
        id: 'jutro.component.unsupportedbrowserbanner.firefoxBrowser',
        defaultMessage: 'Firefox',
    },
    warning: {
        id: 'jutro.component.unsupportedbrowserbanner.warning',
        defaultMessage: 'Warning icon',
    },
    closeIcon: {
        id: 'jutro.component.unsupportedbrowserbanner.closeIcon',
        defaultMessage: 'Close',
    },
    opensInNewTab: {
        id: 'jutro.component.unsupportedbrowserbanner.opensInNewTab',
        defaultMessage: 'opens in new tab',
    },
});
 